var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Subtract"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 27.0952C0.514717 29.8859 2.96058 32 5.9002 32H12.1205L7.45405 25.248C7.32746 25.2496 7.20014 25.2505 7.0721 25.2505H0V27.0952Z",
    fill: "url(#paint0_linear_813_8288)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.8003H6.62069C9.12852 18.8003 11.001 18.267 12.2382 17.2003C13.4754 16.1003 14.094 14.6003 14.094 12.7002C14.094 10.7669 13.4754 9.26683 12.2382 8.20015C11.001 7.13346 9.12852 6.60012 6.62069 6.60012H0V18.8003Z",
    fill: "url(#paint1_linear_813_8288)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0721 0C10.2153 0 12.9237 0.516676 15.1975 1.55003C17.4713 2.55005 19.2267 4.00007 20.4639 5.90011C21.7011 7.80014 22.3197 10.0668 22.3197 12.7002C22.3197 15.3003 21.7011 17.5503 20.4639 19.4504C19.2267 21.3171 17.4713 22.7504 15.1975 23.7504C15.1746 23.7605 15.1516 23.7705 15.1287 23.7805L20.8743 32H26.0001C29.3137 32 32 29.3137 32 26V6.00005C32 2.68631 29.3137 0 26.0001 0H7.0721Z",
    fill: "url(#paint2_linear_813_8288)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_813_8288",
    x1: -23.1731,
    y1: -24,
    x2: 31.8235,
    y2: 32.1724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_813_8288",
    x1: -23.1731,
    y1: -24,
    x2: 31.8235,
    y2: 32.1724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_813_8288",
    x1: -23.1731,
    y1: -24,
    x2: 31.8235,
    y2: 32.1724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconWhite);
export default __webpack_public_path__ + "static/media/LogoIcon-white.94274963db988e34bb889eb24965e2dd.svg";
export { ForwardRef as ReactComponent };